module.exports = __webpack_public_path__ + "static/media/cta_image.e92dfe35.png";